"use strict";

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.find-index");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.some");

require("core-js/modules/es.array.splice");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var EventDispatcher = /*#__PURE__*/function () {
  function EventDispatcher() {
    _classCallCheck(this, EventDispatcher);

    this._listeners = [];
  }

  _createClass(EventDispatcher, [{
    key: "addEventListener",
    value: function addEventListener(type, listener, options) {
      if (!this.hasEventListener(type, listener)) {
        this._listeners.push({
          type: type,
          listener: listener,
          options: {
            once: (options === null || options === void 0 ? void 0 : options.once) || false
          }
        });
      }

      return this;
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(event) {
      var _this = this;

      this._listeners.filter(function (item) {
        return item.type === event.type;
      }).forEach(function (item) {
        var type = item.type,
            listener = item.listener,
            once = item.options.once;
        listener.call(_this, event);

        if (once === true) {
          _this.removeEventListener(type, listener);
        }
      });

      return this;
    }
  }, {
    key: "hasEventListener",
    value: function hasEventListener(type, listener) {
      return this._listeners.some(function (item) {
        return item.type === type && item.listener === listener;
      });
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, listener) {
      var index = this._listeners.findIndex(function (item) {
        return item.type === type && item.listener === listener;
      });

      if (index >= 0) {
        this._listeners.splice(index, 1);
      }

      return this;
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      this._listeners = [];
      return this;
    }
  }]);

  return EventDispatcher;
}();

exports.default = EventDispatcher;